<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" class="position-relative"
      >
        <v-btn
          @click="routerBack"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-toolbar-title 
          class="text-center" 
          style="
            position: absolute; 
            left: 0; 
            right: 0; 
            width: 100%; 
            margin-left: 0; 
            pointer-events: none;
          "
        >
          {{ t('familyEdit.title') }}
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          @click="putFamilyById"
          :loading="btnLoading"
          variant="text"
          class="font-weight-bold mr-2"
  >
          {{ t('familyEdit.save') }}
        </v-btn>
      </v-toolbar>
    </div>

    <v-form ref="put_me_form"  class="content_wrapper px-2 py-3">
      <div>
        <p class="body-2 blue-grey--text">{{ t('familyEdit.familyName') }}</p>
        <v-text-field
          v-model="familyName"
          :rules="[rules.required]"
          outlined
          dense></v-text-field>
      </div>

      <!-- 
      <div>
        <p class="body-2 blue-grey--text">郵便番号</p>
        <v-text-field v-model="postalCode" outlined dense></v-text-field>
      </div>

      <div>
        <p class="body-2 blue-grey--text">県</p>
        <v-text-field v-model="prefecture" outlined dense></v-text-field>
      </div>

      <div>
        <p class="body-2 blue-grey--text">住所</p>
        <v-text-field v-model="address" outlined dense></v-text-field>
      </div>

      <div>
        <p class="body-2 blue-grey--text">建物・部屋番号</p>
        <v-text-field v-model="building" outlined dense></v-text-field>
      </div>
       -->

      <!-- <div class="d-flex">
        <v-btn
          @click="putFamilyById"
          :loading="btnLoading"
          color="primary"
          block
        >
          登録
        </v-btn>
      </div> -->
    </v-form>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { Toast } from '@/service/SweetAlert';
import rules from '@/service/ValidRules';

import { familyModule } from '@/store/entityModules/family';
import { t } from '@/i18n';

import { VForm } from '@/model/Vuetify/VForm';

interface DataType {
  familyName: string | null;
  postalCode: string | null;
  prefecture: string | null;
  address: string | null;
  building: string | null;
  btnLoading: boolean | null;
}

export default defineComponent({
  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).put_me_form;
    },
    family() {
      return familyModule.family;
    },
  },

  data: (): DataType => ({
    familyName: null,
    postalCode: null,
    prefecture: null,
    address: null,
    building: null,
    btnLoading: false,
  }),

  methods: {
    t,
    routerBack() {
      this.$router.replace('/setting/family');
    },
    async putFamilyById() {
      if (this.form.validate() && this.family) {
        try {
          this.btnLoading = true;
          const response = await familyModule.putFamilyById({
            familyId: String(this.family.familyId),
            familyName: this.familyName,
            postalCode: this.postalCode,
            prefecture: this.prefecture,
            address: this.address,
            building: this.building,
            parents: this.family.parents.map((p) => {
              return {
                parentId: String(p.parentId),
                parentType: p.parentType,
              };
            }),
          });
          this.btnLoading = false;
          await familyModule.fetchFamilyById({
            familyId: this.family.familyId,
          });
          Toast.fire({
            icon: 'success',
            title: this.t('familyEdit.successMessage'),
          });
        } catch (error) {
          this.btnLoading = false;
        }
      }
    },
  },

  async mounted() {
    if (this.family) {
      this.familyName = this.family.familyName;
      this.postalCode = this.family.postalCode;
      this.prefecture = this.family.prefecture;
      this.address = this.family.address;
      this.building = this.family.building;
    }
  },
});
</script>
<style lang="scss" scoped>
/* ===== レイアウト ===== */
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(55px + env(safe-area-inset-top));
}

.picked_img {
  height: 100px;
  width: 100px;
  background-color: #d5d5d5;
  border-radius: 100%;
  img {
    object-fit: cover;
    border-radius: 100%;
    height: 100%;
    width: 100%;
  }
}
.file_uploader {
  height: 100px;
  width: 100px;
  background-color: #d5d5d5;
  border-radius: 100%;
}
</style>
